//Please add the language resource
const route = {
  companyCode: 'companyCode',
  companyName: 'companyName',
  carrierNo: 'carrierNo',
  carrierName: 'carrierName',
  shipperCode: 'shipperCode',
  shipperName: 'shipperName',
  sendProvince: 'sendProvince',
  sendCity: 'sendCity',
  sendArea: 'sendArea',
  receiveProvince: 'receiveProvince',
  receiveCity: 'receiveCity',
  receiveArea: 'receiveArea',
  transTypeName: 'transTypeName',
  businessTypeName: 'businessTypeName',
  otd: 'otd',
  rtd: 'rtd',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',

  company: 'company',
  carrier: 'carrier',
  origin: 'origin',
  dest: 'dest',
};
export default route



// WEBPACK FOOTER //
// ./src/page/mdm/route/lang/circuit.en.js